import {
  FormMetaModel,
  SmMetaInputModel,
} from 'common/models/utility-models/meta-model';

export class RegisterStep2MetaModel extends FormMetaModel {
  constructor() {
    super(
      '',
      '',
      '',
      3,
      null,
      true,
      'step2',
      '',
      ' row align-items-start justify-content-start'
    );
  }

  override initProperties(): any {
    const formInfo = super.initProperties();
    const fatherName = new SmMetaInputModel(
      'fatherName',
      'fatherName',
      'input',
      true,
      'col-12 col-md-6',
      1,
      1,
      `Father's full Name`,
      'text',
      "^(?=.*[a-zA-Z])[a-zA-Z '-]+$",
      false,
      true,
      true,
      false,
      100,
      1,
      // false,
      // false,
      // false,
      // false,
      // false,
      // false,
      // false,
      // '',
      // { evalKey: '', evalParam: [] },
      // false,
      // [],
      // false,
      // '',
      // null,
      // false,
      // false,
      // false,
      // `Father's full Name`
    );
    const fatherProfession = new SmMetaInputModel(
      'fatherProfession',
      'fatherProfession',
      'input',
      false,
      'col-12 col-md-6',
      1,
      1,
      `Father's Profession`,
      'text',
      "^(?=.*[a-zA-Z])[a-zA-Z '-]+$",
      false,
      true,
      true,
      false,
      100,
      1,
      // false,
      // false,
      // false,
      // false,
      // false,
      // false,
      // false,
      // '',
      // { evalKey: '', evalParam: [] },
      // false,
      // [],
      // false,
      // '',
      // null,
      // false,
      // false,
      // false,
      // `Father's Profession`
    );
    const motherName = new SmMetaInputModel(
      'motherName',
      'motherName',
      'input',
      true,
      'col-12 col-md-6 ',
      1,
      1,
      `Mother's full Name`,
      'text',
      "^(?=.*[a-zA-Z])[a-zA-Z '-]+$",
      false,
      true,
      true,
      false,
      100,
      1,
      // false,
      // false,
      // false,
      // false,
      // false,
      // false,
      // false,
      // '',
      // { evalKey: '', evalParam: [] },
      // false,
      // [],
      // false,
      // '',
      // null,
      // false,
      // false,
      // false,
      // `Mother's full Name`
    );
    const motherProfession = new SmMetaInputModel(
      'motherProfession',
      'motherProfession',
      'input',
      false,
      'col-12 col-md-6 ',
      1,
      1,
      `Mother's Profession`,
      'text',
      "^(?=.*[a-zA-Z])[a-zA-Z '-]+$",
      false,
      true,
      true,
      false,
      100,
      1,
      // false,
      // false,
      // false,
      // false,
      // false,
      // false,
      // false,
      // '',
      // { evalKey: '', evalParam: [] },
      // false,
      // [],
      // false,
      // '',
      // null,
      // false,
      // false,
      // false,
      // `Mother's Profession`
    );

    const familyAnnualIncome = new SmMetaInputModel(
      'familyAnnualIncome',
      'familyAnnualIncome',
      'input',
      true,
      'col-12 col-md-6',
      1,
      1,
      'Family Annual Income',
      'number',
      '',
      false,
      true,
      true,
      false,
      10,
      1,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      '',
      { evalKey: '', evalParam: [] },
      false,
      [],
      false,
      '',
      null,
      false,
      false,
      false,
      'Family income must be less than 2 lakh per annum to be eligible',
      true,
      true
    );

    return {
      formInfo,
      fatherName,
      fatherProfession,
      motherName,
      motherProfession,
      familyAnnualIncome,
    };
  }
}
